import { Injectable } from '@angular/core';
import { NavProviderService } from '@feature/core/navigation/nav-provider.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { MftNavigationProviderService } from '@feature/core/navigation/mft-nav-provider.service';

@Injectable({
  providedIn: 'root'
})
export class NavProviderFactoryService {

  constructor(
    private mftNavigationProviderService: MftNavigationProviderService
    ) {
  }

  get(product: string): NavProviderService {
    switch (product) {
    case MojoWellKnownNames.Products.MojoForTenants:
      return this.mftNavigationProviderService;
      default:
        throw new Error('No nav service for product');
    }
    
  }
}
